<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-suitcase-rolling"></i> Urlopy</h3>
        <div>
          <button class="btn btn-outline-secondary" @click="refresh(true)">
            <i class="fas fa-sync"></i> Odśwież
          </button>
          <button class="btn btn-outline-primary" @click="ShowHolidaySummary()" v-if="true">
            <i class="fas fa-chart-bar"></i> Podsumowanie roczne
          </button>
          <button
            class="btn btn-outline-primary"
            @click="ShowHolidayForm()"
            v-if="isAdmin"
          >
            <i class="fas fa-plus"></i> Dodaj urlop
          </button>
        </div>
      </div>
      <div class="portlet-body">
        <div class="isLoading-wraper">
          <full-calendar :options="calendar" ref="calendar"></full-calendar>
          <TableSpiner id="isLoading" style="display: none" />
        </div>
      </div>
    </div>
    <ModalHolidaysForm
      ref="holidaysModal"
      @onSubmit="submitNewEvent"
      @onUpdate="updateEvenCalendar"
      :event="selectedItem"
    />
    <ModalHolidaysEvent
      :event="selectedItem"
      @onRemove="removeEventFromCalendar"
      @onEdit="ShowHolidayForm"
    />
    <ModalHolidaysSummary :event="items" :year="currentYear" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import HolidaysService from "@/services/holidays.service";
import TableSpiner from "../components/TableSpiner";
import ModalHolidaysForm from "@/components/holidays/ModalHolidaysForm";
import ModalHolidaysEvent from "@/components/holidays/ModalHolidaysEvent";
import ModalHolidaysSummary from "@/components/holidays/ModalHolidaysSummary";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

//TOOD: dodać zmiane event na zmiane roku
export default {
  name: "TheHolidays",
  components: {
    TableSpiner,
    FullCalendar,
    ModalHolidaysForm,
    ModalHolidaysEvent,
    ModalHolidaysSummary,
  },
  data() {
    return {
      items: null,
      currentYear: null,
      selectedItem: {},
      calendar: {
        aspectRatio: 1.8,
        nextDayThreshold: "00:00:00",
        displayEventTime: false,
        events: this.getEvents,
        showNonCurrentDates: false,
        lazyFetching: true,
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "prevYear,prev",
          center: "title",
          right: "next,nextYear",
        },
        eventClick: this.showDetails,
      },
    };
  },
  computed: {
    ...mapGetters("user", ["isAdmin"]),
  },
  methods: {
    getEvents(info, successCallback, failureCallback) {
      if (this.currentYear === null) {
        this.currentYear = info.start.getFullYear();
      } else if (this.currentYear !== info.start.getFullYear()) {
        this.currentYear = info.start.getFullYear();
        this.items = null;
      }
      if (this.$_.isArray(this.items) === false) {
        const isLoading = document.querySelector("#isLoading");
        isLoading.style.display = "flex";
        return HolidaysService.getByYear(this.currentYear)
          .then((items) => {
            this.items = [];
            for (var x = 0, n = items.length; x < n; x++) {
              this.items.push(this.formatEvent(items[x]));
            }
            successCallback(this.items);
          })
          .catch(function (e) {
            failureCallback(e);
          })
          .finally(() => {
            isLoading.style.display = "none";
          });
      } else {
        successCallback(this.items);
      }
    },
    ShowHolidayForm(isEdit) {
      if (isEdit !== true) {
        this.selectedItem = {};
      }
      this.$nextTick(() => {
        this.$bvModal.show("holidays-modal");
      });
    },
    showDetails(clicked) {
      let eventID = clicked.event.id;
      let eventIndex = this.items.findIndex((item) => item.id == eventID);
      if (eventIndex < 0) return;
      this.selectedItem = this.items[eventIndex];
      this.$nextTick(() => {
        this.$bvModal.show("holidaysEvent-modal");
      });
    },
    ShowHolidaySummary() {
      this.selectedItem = { extendedProps: {} };
      this.$nextTick(() => {
        this.$bvModal.show("holidaysSummary-modal");
      });
    },
    submitNewEvent(data) {
      this.items.push(this.formatEvent(data));
      this.refresh();
    },
    removeEventFromCalendar(eventId) {
      let eventIndex = this.items.findIndex((item) => item.id == eventId);
      if (eventIndex >= 0) this.items.splice(eventIndex, 1);
      this.refresh();
    },
    updateEvenCalendar(data) {
      this.formatEvent(data);
      this.$_.forEach(data, (item, key) => {
        this.selectedItem[key] = item;
      });
      this.refresh();
    },
    formatEvent(data) {
      data.start = data.start + "T00:00:00";
      data.end = data.end + "T23:59:59";
      data.color = this.setupBackgroundColor(data.type);
      data.textColor = this.setupTypeColor(data.type);
      return data;
    },
    setupBackgroundColor(type) {
      if (type === "holiday") {
        return "#8ce46c7c";
      } else if (type === "sickness") {
        return "#f1cb317e";
      }
      return "#35b4f980";
    },
    setupTypeColor(type) {
      if (type === "holiday") {
        return "#5c8f44";
      } else if (type === "sickness") {
        return "#b4740f";
      }
      return "#1979a9";
    },
    refresh(cleanItems = false) {
      if (cleanItems === true) {
        this.$Progress.start();
        this.items = null;
      }
      this.$refs.calendar.getApi().refetchEvents();
    },
  },
};
</script>

<style scoped>
.isLoading-wraper {
  position: relative;
}
#isLoading {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto !important;
  background: rgba(0, 0, 0, 0.25);
  z-index: 11;
}
</style>